import { categoryService, productService } from '@cabukaka/services';
import { PageContainer } from '../../../components/ui/PageContainer';
import PageHeader from '../../../components/ui/PageHeader';
import Hero from '../../../components/sections/category/Hero';
import FiltersBar from '../../../components/sections/category/FiltersBar';
import CategoryProducts from '../../../components/sections/category/CategoryProducts';
import SuggestionCategories from '../../../components/sections/category/SuggestionCategories';
import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Category, Product } from '@cabukaka/types';
import { NotFoundContent } from '../../../components/ui/NotFoundContent';

export default function CategoryPage() {
    const { slug } = useParams();
    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || 'latest';

    const [products, setProducts] = useState<Product[]>([]);
    const [category, setCategory] = useState<Category | null>(null);
    const [similarCategories, setSimilarCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (!slug) return;

            try {
                const [productsData, categoryData, similarCategoriesData] = await Promise.all([
                    productService.getProductByCategorySlug(slug),
                    categoryService.getCategoryBySlug(slug),
                    categoryService.getCategoriesBySectorSlug(slug)
                ]);

                setProducts(productsData?.data || []);
                setCategory(categoryData);
                setSimilarCategories(similarCategoriesData?.data || []);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    if (loading) {
        return (
            <PageContainer className="min-h-screen bg-gray-50">
                <div className="flex items-center justify-center min-h-[60vh]">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
                </div>
            </PageContainer>
        );
    }

    if (!category) {
        return (
            <PageContainer className="min-h-screen bg-gray-50">
                <NotFoundContent
                    iconName="Grid3x3"
                    title="Catégorie non trouvée"
                    description="La catégorie que vous recherchez n'existe pas ou a été supprimée."
                    actionLabel="Voir toutes les catégories"
                    actionHref="/categories"
                />
            </PageContainer>
        );
    }

    return (
        <PageContainer className="min-h-screen bg-gray-50">

            <PageHeader
                breadcrumb={[
                    { label: "Catégories", href: "/categories" },
                    { label: category.name, href: "" }
                ]}
            />

            <Hero category={category} />

            <FiltersBar sort={sort} products={products} />

            <CategoryProducts products={products} />

            {similarCategories && similarCategories.length > 0 && (
                <SuggestionCategories categories={similarCategories} />
            )}

        </PageContainer>
    );
}